import React, { Component, useEffect, useState } from "react";
import Box from '@material-ui/core/Box';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {  Grid,ListItem,Button,Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Controller, useForm, } from "react-hook-form";
import {
    SetOrganisationContact,
  } from "../../Pages/Roles/Admin/Organisation/Create/Contact/OrganisationContactActions";
  import { useDispatch, useSelector } from "react-redux";

export const CheckboxesGroup = (props) => {
    const dispatch = useDispatch();
    const {
        label,
        id,
        index,
        value,
        // handleChange,
        helperText,
        selectValue,
        placeholder,
        futureDateHide,
        selectOptions,
        name
      } = props.componentObject;

    const [state, setState] = React.useState({
        Sole: false,
        Shared: false,
        OtherServices: false,
      });
    //   const OrgId = useSelector(
    //     (state) => state.organisationDetailsReducer.fully_managed_service
    //   );
      const handleChange = (event) => {
        setState({
          ...state,
          [event.target.name]: event.target.checked,
        });
        
      };
      useEffect(() => {
    //   console.log(`state123`, state)
        dispatch(SetOrganisationContact({"fully_managed_service":{...state}}));
    }, [state])
  const { Sole, Shared, OtherServices } = state;
//   const error = [gilad, jason, antoine].filter((v) => v).length !== 2;

  return (
    <Box sx={{ display: 'flex' }}>
      <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
      <FormLabel component="legend">Fully Managed Service</FormLabel>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox checked={Sole} onChange={handleChange} name={"Sole"} />
            }
            label="Sole"
          />
          <FormControlLabel
            control={
              <Checkbox checked={Shared} onChange={handleChange} name={"Shared"} />
            }
            label="Shared"
          />
          <FormControlLabel
            control={
              <Checkbox checked={OtherServices} onChange={handleChange} name={"OtherServices"} />
            }
            label="OtherServices"
          />
        </FormGroup>
        {/* <FormHelperText>Be careful</FormHelperText> */}
      </FormControl>
      {/* <FormControl
        required
        error={error}
        component="fieldset"
        sx={{ m: 3 }}
        variant="standard"
      >
        <FormLabel component="legend">Pick two</FormLabel>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox checked={gilad} onChange={handleChange} name="gilad" />
            }
            label="Gilad Gray"
          />
          <FormControlLabel
            control={
              <Checkbox checked={jason} onChange={handleChange} name="jason" />
            }
            label="Jason Killian"
          />
          <FormControlLabel
            control={
              <Checkbox checked={antoine} onChange={handleChange} name="antoine" />
            }
            label="Antoine Llorca"
          />
        </FormGroup>
        <FormHelperText>You can display an error</FormHelperText>
      </FormControl> */}
    </Box>
  );
}

export default function CheckboxesGroupComponent(props) {
    // console.log(props.componentObject)
    const { label } = props.componentObject; 
     const [anchorEl, setAnchorEl] = useState("");
  
    const handleClick = (event) => {
      setAnchorEl("display");
    };
    useEffect(() => {
  }, [props])
  
    return (
      <Grid container >
        {
          label &&
          <Grid item xs={12} md={4}>
            {label}
          </Grid>
        }
     
   
        
        <Grid item xs={12} md={label ? 7 : 12}>
        <CheckboxesGroup componentObject={props.componentObject} />
       
      </Grid>
      
        
      </Grid>
      // </form>
    );
  }
